import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
import generations from './generations'
/**
* @see \App\Http\Controllers\Ai\AiTransactionReportController::index
* @see Http/Controllers/Ai/AiTransactionReportController.php:25
* @route '/ai/transactions/reports'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/ai/transactions/reports',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Ai\AiTransactionReportController::index
* @see Http/Controllers/Ai/AiTransactionReportController.php:25
* @route '/ai/transactions/reports'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Ai\AiTransactionReportController::index
* @see Http/Controllers/Ai/AiTransactionReportController.php:25
* @route '/ai/transactions/reports'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Ai\AiTransactionReportController::index
* @see Http/Controllers/Ai/AiTransactionReportController.php:25
* @route '/ai/transactions/reports'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Ai\AiTransactionReportController::store
* @see Http/Controllers/Ai/AiTransactionReportController.php:83
* @route '/ai/transactions/reports'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/ai/transactions/reports',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Ai\AiTransactionReportController::store
* @see Http/Controllers/Ai/AiTransactionReportController.php:83
* @route '/ai/transactions/reports'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Ai\AiTransactionReportController::store
* @see Http/Controllers/Ai/AiTransactionReportController.php:83
* @route '/ai/transactions/reports'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Ai\AiTransactionReportController::show
* @see Http/Controllers/Ai/AiTransactionReportController.php:71
* @route '/ai/transactions/reports/{report}'
*/
export const show = (args: { report: string | number } | [report: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/ai/transactions/reports/{report}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Ai\AiTransactionReportController::show
* @see Http/Controllers/Ai/AiTransactionReportController.php:71
* @route '/ai/transactions/reports/{report}'
*/
show.url = (args: { report: string | number } | [report: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { report: args }
    }

    if (Array.isArray(args)) {
        args = {
            report: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        report: args.report,
    }

    return show.definition.url
            .replace('{report}', parsedArgs.report.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Ai\AiTransactionReportController::show
* @see Http/Controllers/Ai/AiTransactionReportController.php:71
* @route '/ai/transactions/reports/{report}'
*/
show.get = (args: { report: string | number } | [report: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Ai\AiTransactionReportController::show
* @see Http/Controllers/Ai/AiTransactionReportController.php:71
* @route '/ai/transactions/reports/{report}'
*/
show.head = (args: { report: string | number } | [report: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

const reports = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    generations: Object.assign(generations, generations),
    show: Object.assign(show, show),
}

export default reports